<vw-check-row [checked]="checked" [label]="task.name | Label" (check)="check.emit()" (open)="open.emit()">
  @if (task.gardenTask; as gesture) {
    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-pill bg-vw-surface-tint text-title-m" aria-hidden="true">{{ emojis[gesture.category] }}</span>
  }
  <span class="min-w-0 flex-1" [class.opacity-60]="checked">
    <span data-test="task-title" class="block truncate text-body font-semibold text-vw-ink" [class.line-through]="checked">{{ task.name | Label }}</span>
    <span class="mt-0.5 flex items-center gap-2">
      @if (task.gardenTask?.cropLabel; as crop) {
        <span class="whitespace-nowrap rounded-pill bg-vw-surface-tint px-2 py-0.5 text-caption text-vw-primary-ink">{{ crop }}</span>
      }
      @if (!pastWindow) {
        <span data-test="task-due" class="truncate text-body-s text-vw-muted">{{ 'tasks.due.until' | translate: { date: task.endDate | vwDate: 'day-month' } }}</span>
      }
    </span>
  </span>
</vw-check-row>
